import { render } from "./pop-alert.vue?vue&type=template&id=7abde0cd&scoped=true&ts=true"
import script from "./pop-alert.vue?vue&type=script&lang=ts"
export * from "./pop-alert.vue?vue&type=script&lang=ts"

import "./pop-alert.vue?vue&type=style&index=0&id=7abde0cd&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abde0cd"]])

export default __exports__